import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=48ab52f3&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=ts"
export * from "./OfferCard.vue?vue&type=script&lang=ts"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=48ab52f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab52f3",
  null
  
)

export default component.exports